module.exports = __webpack_public_path__ + "teqbahn-assets/media/19.0c3c8d86.png";